import { render, staticRenderFns } from "./fpddue.vue?vue&type=template&id=258f551c&scoped=true&"
import script from "./fpddue.vue?vue&type=script&lang=js&"
export * from "./fpddue.vue?vue&type=script&lang=js&"
import style0 from "./fpddue.vue?vue&type=style&index=0&id=258f551c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258f551c",
  null
  
)

export default component.exports